import React, {
  useContext, useEffect, useState, useRef,
} from 'react';
import { KickCounterContext } from '../../context/KickCounterContext';
import Time from './Time';
import styles from './StopWatch.module.css';
import { COUNTER_MODE, TIME_WARN_2 } from '../../constants/constants';

export default function StopWatch({ active }) {
  const [isActive, setIsActive] = useState(false);
  const [timeColor, setTimeColor] = useState('black');
  const {
    time, startTime, setStartTime, setTime, counterMode, setSessionStartTime,
  } = useContext(KickCounterContext);
  const startTimeByRef = useRef();
  startTimeByRef.current = startTime;

  useEffect(() => {
    if (counterMode === COUNTER_MODE.TIME && time >= TIME_WARN_2) {
      setTimeColor('CornflowerBlue');
    }
  }, [time]);

  useEffect(() => {
    let interval = null;
    if (isActive) {
      setSessionStartTime(new Date());
      interval = setInterval(() => {
        if (startTimeByRef.current === null) {
          setStartTime(Date.now());
        } else {
          setTime(time + Math.round((Date.now() - startTimeByRef.current) / 1000));
        }
      }, 1000);
    } else {
      setStartTime(null);
      clearInterval(interval);
    }

    return () => {
      setStartTime(null);
      clearInterval(interval);
    };
  }, [isActive]);

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  return (
    <div className={styles.container}>
      <Time color={timeColor} time={time} />
    </div>
  );
}
